import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "../../nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = { progress: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  getMasterKey() {
    return this.props.params && this.props.params.masterKey;
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    return (
      <div
        className="vh-100"
        style={{
          background:
            "linear-gradient(135deg, #1F4D2C 0%, #2d6b3f 50%, #0F2818 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            opacity: 0.03,
            background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            pointerEvents: "none",
          }}
        ></div>

        <div className="d-flex h-100 align-items-center justify-content-center p-3">
          <div className="container" style={{ maxWidth: "1000px" }}>
            <div
              className="bg-white rounded"
              style={{
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <div className="row g-0">
                <div
                  className="col-md-5 d-none d-md-flex"
                  style={{
                    background:
                      "linear-gradient(180deg, #83c14a 0%, #6fa83e 100%)",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      opacity: 0.1,
                      background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                      pointerEvents: "none",
                    }}
                  ></div>

                  <div
                    className="h-100 d-flex flex-column align-items-center justify-content-center p-5 text-center"
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      className="mb-4"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "20px",
                        background: "rgba(255, 255, 255, 0.15)",
                        backdropFilter: "blur(10px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      <img
                        alt="company logo"
                        src="/figaro.png"
                        style={{
                          width: "70px",
                          height: "70px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    <h2
                      className="text-white fw-bold mb-3"
                      style={{ fontSize: "1.75rem", letterSpacing: "-0.5px" }}
                    >
                      Business Intelligence
                    </h2>

                    <p
                      className="text-white mb-0"
                      style={{
                        opacity: 0.9,
                        fontSize: "1rem",
                        lineHeight: "1.6",
                      }}
                    >
                      Analytics Platform for Figaro Coffee Group
                    </p>

                    <div className="mt-5 d-flex gap-3">
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "12px",
                          background: "rgba(255, 255, 255, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <i
                          className="bi bi-graph-up"
                          style={{ fontSize: "1.5rem", color: "#fff" }}
                        ></i>
                      </div>
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "12px",
                          background: "rgba(255, 255, 255, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <i
                          className="bi bi-bar-chart-line"
                          style={{ fontSize: "1.5rem", color: "#fff" }}
                        ></i>
                      </div>
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "12px",
                          background: "rgba(255, 255, 255, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <i
                          className="bi bi-pie-chart"
                          style={{ fontSize: "1.5rem", color: "#fff" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-7">
                  <div className="p-4 p-lg-5">
                    <div className="text-center mb-4 d-md-none">
                      <img
                        alt="Figaro Coffee"
                        src="/figaro.png"
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "contain",
                          marginBottom: "16px",
                        }}
                      />
                    </div>

                    <div className="mb-4">
                      <h2
                        className="fw-bold mb-2"
                        style={{
                          color: "#111827",
                          fontSize: "1.875rem",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Welcome Back
                      </h2>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "1rem" }}
                      >
                        Sign in to access your analytics dashboard
                      </p>
                    </div>

                    <form onSubmit={this.formSubmit.bind(this)}>
                      <div className="mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#374151", fontSize: "0.875rem" }}
                        >
                          Email Address
                        </label>
                        <InputFactory
                          required
                          type="email"
                          autoComplete="nope"
                          className="form-control"
                          placeholder="Enter your email"
                          field="username"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>

                      <div className="mb-4">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#374151", fontSize: "0.875rem" }}
                        >
                          Password
                        </label>
                        <InputFactory
                          type="Password"
                          required
                          className="form-control"
                          placeholder="Enter your password"
                          field="password"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>

                      <Button
                        progress={this.state.progress}
                        type="submit"
                        className="btn w-100 fw-semibold"
                        style={{
                          background:
                            "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
                          border: "none",
                          padding: "14px",
                          fontSize: "1rem",
                          borderRadius: "10px",
                          color: "#fff",
                          boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 20px rgba(131, 193, 74, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(131, 193, 74, 0.3)";
                        }}
                      >
                        {this.state.progress ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Signing in...
                          </>
                        ) : (
                          "Sign In"
                        )}
                      </Button>

                      <div className="mt-4 text-center">
                        <small
                          style={{ color: "#9CA3AF", fontSize: "0.8125rem" }}
                        >
                          <i className="bi bi-shield-check me-1"></i>
                          Your data is secure and encrypted
                        </small>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <small
                className="text-white"
                style={{ opacity: 0.7, fontSize: "0.875rem" }}
              >
                © 2026 Figaro Coffee Group. All rights reserved.
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
